import { cn } from "@/lib/utils";

import { Skeleton } from "@/components/ui/skeleton";

export interface ProductCardSkeletonProps {
  className?: string;
}

export function ProductCardSkeleton({ className }: ProductCardSkeletonProps) {
  return (
    <div className={cn("rounded-sm border bg-card overflow-hidden flex flex-col", className)}>
      <Skeleton className="aspect-square w-full" />
      <div className="p-4 flex flex-col gap-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-5 w-24 mt-1" />
      </div>
    </div>
  );
}
